module.exports = __webpack_public_path__ + "static/img/logo-techik.20868f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-techik.jpg
// module id = Ky1K
// module chunks = 118